export enum TextRowAmount {
  ROWAMOUNT_SINGLE = 1,
  ROWAMOUNT_XXS = 2,
  ROWAMOUNT_XS = 4,
  ROWAMOUNT_S = 5,
  ROWAMOUNT_M = 10,
  ROWAMOUNT_L = 15
}
